
/**
 * Reservation (Wonderland API) boolean values
 */
export type ReservationApiBoolean = 'Y' | 'N';


/**
 * Reservation menu actions enum
 *
 * @export
 * @enum {string}
 */
export enum ReservationMenuActionType {
  Booking = 'booking',
  OpenBookingMaster = 'OpenBookingMaster',
  CrystalCruiseFAQ = 'crystalcruiseFAQ',
  OpenDepositNew = 'OpenDepositNew',
  OpenDepositPast = 'OpenDepositPast',
  FloatingDeposit = 'FloatingDeposit',
  FloatingDepositWC = 'FloatingDepositWC',
  GoodwillDeposit = 'GoodwillDeposit',
  AlianzLink = 'AlianzLink',
  AlianzLink2 = 'AlianzLink2',
  Ticketing = 'ticketing',
  HeritageDeposit = 'HeritageDeposit',
}

/**
 * Brand IDs used across reservation.
 */
export enum BrandIDEnum {
  AKORN = 1,
  AK = 2,
  CRYSTAL_CRUISES = 3,
  COX_AND_KINGS = 4,
  AK_PHILANTHROPY = 5,
  ECOVENTURA = 7,
}

/**
 * Centralized service type IDs used across reservation / setup.
 */
export enum ServiceTypeIDEnum {
  CRUISE_DISCOUNT_SERVICE_TYPE_ID = 1,
  BOOKING_FEE = 2,
  ACCOMODATION_SERVICE_TYPE_ID = 3,
  CAR_RENTAL_SERVICE_TYPE_ID = 4,
  GUID_SERVICE_TYPE_ID = 5,
  OVERNIGHT_CRUISE_SERVICE_TYPE_ID = 6,
  //VILLA_SERVICE_TYPE_ID = 6,
  SUNDRIES_SERVICE_TYPE_ID = 7,
  ENTERTAINMENT_SERVICE_TYPE_ID = 8,
  ENTRANCE_FEE_SERVICE_TYPE_ID = 9,
  EXCURSION_SERVICE_TYPE_ID = 10,
  FLIGHTS_SERVICE_TYPE_ID = 11,
  FOOD_SERVICE_TYPE_ID = 12,
  GIFT_AND_MERCHANDISING_SERVICE_TYPE_ID = 13,
  TOURS_SERVICE_TYPE_ID = 14,
  SLEEPER_TRAIN_SERVICE_TYPE_ID = 15,
  TRANSPORTS_SERVICE_TYPE_ID = 16,
  PENALTY_SERVICE_TYPE_ID = 24,
  BOOKING_DISCOUNT_SERVICE_TYPE_ID = 25,
  ESCORT_SERVICE_TYPE_ID = 30,
  EXPENSES_SERVICE_TYPE_ID = 36,
  VISA_SERVICE_TYPE_ID = 38,
  GOODWILL_SERVICE_TYPE_ID = 39,
  TAILOR_MADE_SERVICE_TYPE_ID = 40,
  TM_GENERIC_SERVICE_TYPE_ID = 40,
  PERMIT_SERVICE_TYPE_ID = 41,
  AGENT_GIFT_SERVICE_TYPE_ID = 42,
  ASSURANCE_PROGRAM_SERVICE_TYPE_ID = 43,
  FREE_SHOREX_SERVICE_TYPE_ID = 44,
  POINT_OF_INTEREST_SERVICE_TYPE_ID = 45,
  AK_REPRESENTATIVE_SERVICE_TYPE_ID = 46,
  ADDITIONAL_CAMP_SERVICE_TYPE_ID = 47,
  EVENTS_SERVICE_TYPE_ID = 48,
  CONSORTIUM_SERVICE_TYPE_ID = 49,
  EXTRA_ONLY = 50,
  ACCOMODATION_FEE = 51,
  BOOKING_SUPPLEMENT_SERVICE_TYPE_ID = 54,
  MARGIN_OVERLAY_SERVICE_TYPE_ID = 55,
  DMC_AGENT_COMMISSION_SERVICE_TYPE_ID = 56,
  DESIGN_YOUR_DAY_SERVICE_TYPE_ID = 57,
  TOOLKIT_DISCOUNT_SERVICE_TYPE_ID = 999,
  EXPERIENCE_SERVICE_TYPE_ID = 5000,
  DMC_UNALLOCATED_CREDIT_SERVICE_TYPE_ID = 58,
}

export var resBkgItemStatusValuesAll = [
  { value: 'A', displayValue: 'Confirmed', exclude: false },
  { value: 'M', displayValue: 'DMC Confirmed', exclude: true },
  { value: 'R', displayValue: 'On Request', exclude: true },
  { value: 'W', displayValue: 'Wait List', exclude: false },
]
